export default __webpack_public_path__ + "static/media/web-01.baf4fc27.svg";